import { Box, FormControl, MenuItem, Select } from '@mui/material';
import Label from 'components/@home/drawers/AppDrawer/Form/Label';
import ExpirationPicker from 'components/@home/@documents/SentDocuments/steps/StepMessage/ExpirationPicker';
import { func, object } from 'prop-types';
import React, { useCallback } from 'react';
import { I18n } from 'utils/i18n';

const DeliveryExpiryReminderFields = ({ deliveryOptions, setDeliveryOptions }) => {
  const reminderMode =
    deliveryOptions.reminderIntervalDays === '7' || deliveryOptions.reminderIntervalDays === 7
      ? 'weekly'
      : deliveryOptions.reminderIntervalDays === '3' || deliveryOptions.reminderIntervalDays === 3
        ? 'every3'
        : 'off';

  const onExpirationChange = useCallback(
    ({ preset, expiresAt }) => {
      setDeliveryOptions(opts => ({
        ...opts,
        expiresPreset: preset,
        expiresAt,
      }));
    },
    [setDeliveryOptions],
  );

  const onReminderChange = useCallback(
    e => {
      const mode = e.target.value;
      const reminderIntervalDays = mode === 'every3' ? '3' : mode === 'weekly' ? '7' : '';
      setDeliveryOptions(opts => ({ ...opts, reminderIntervalDays }));
    },
    [setDeliveryOptions],
  );

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'flex-start',
          mt: 0.5,
        }}
      >
        <Box sx={{ minWidth: 200, flex: '1 1 200px' }}>
          <Label sx={{ mt: 0 }}>{I18n.t('HrBot.DeliveryOptions.expiresAt')}</Label>
          <ExpirationPicker
            preset={deliveryOptions.expiresPreset || ''}
            expiresAt={deliveryOptions.expiresAt || ''}
            onChange={onExpirationChange}
          />
        </Box>
        <Box sx={{ minWidth: 200, flex: '1 1 200px' }}>
          <Label sx={{ mt: 0 }}>{I18n.t('HrBot.DeliveryOptions.reminders')}</Label>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              inputProps={{ 'aria-label': I18n.t('HrBot.DeliveryOptions.reminders') }}
              value={reminderMode}
              onChange={onReminderChange}
            >
              <MenuItem value="off">{I18n.t('HrBot.DeliveryOptions.reminderMode.off')}</MenuItem>
              <MenuItem value="every3">
                {I18n.t('HrBot.DeliveryOptions.reminderMode.every3')}
              </MenuItem>
              <MenuItem value="weekly">
                {I18n.t('HrBot.DeliveryOptions.reminderMode.weekly')}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

DeliveryExpiryReminderFields.propTypes = {
  deliveryOptions: object.isRequired,
  setDeliveryOptions: func.isRequired,
};

export default DeliveryExpiryReminderFields;
